import { defaultTo } from 'lodash';
import { IModel } from '.';
import { ModelRecord } from './Model';
export interface IPaymentTypeModel extends IModel {
  paymentTypeId: number;
  code: string;
  name: string;
}
export class PaymentTypeModel implements ModelRecord<IPaymentTypeModel> {
  rowVersion: string;
  paymentTypeId: number;
  code: string;
  name: string;

  constructor(params?: Partial<IPaymentTypeModel>) {
    this.rowVersion = defaultTo(params?.rowVersion, '');
    this.paymentTypeId = defaultTo(params?.paymentTypeId, 0);
    this.code = defaultTo(params?.code, '');
    this.name = defaultTo(params?.name, '');
  }
}
